var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 37,
    viewBox: "0 0 176 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8022 3.30566V28.6243H16.0703V17.7232H5.73186V28.6243H0V3.30566H5.73186V12.8705H16.0703V3.30566H21.8022Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5247 19.1997C46.5247 25.037 42.1291 29.081 36.0104 29.081C29.8565 29.081 25.4961 25.037 25.4961 19.1997C25.4961 13.3975 29.8565 9.31836 36.0104 9.31836C42.1291 9.31836 46.5247 13.3975 46.5247 19.1997ZM40.8631 19.1997C40.8631 15.1909 39.14 13.7491 36.0104 13.7491C32.8455 13.7491 31.1576 15.1909 31.1576 19.1997C31.1576 23.2436 32.8455 24.6502 36.0104 24.6502C39.14 24.6502 40.8631 23.2436 40.8631 19.1997Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4435 24.1924V28.6231H57.5644C52.6413 28.6231 49.793 26.0561 49.793 21.6605V0.280273H55.2435V21.4847C55.2435 23.5946 55.982 24.1924 57.8457 24.1924H58.4435Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.771 9.7755V26.303C103.771 32.6678 100.711 36.2195 93.186 36.2195C87.5596 36.2195 85.0278 33.5821 83.6915 29.8195H88.9311C89.4937 31.3667 90.9003 31.8942 93.2563 31.8942C96.8783 31.8942 98.3201 31.0151 98.3201 26.9359V25.3887C97.3354 26.9711 95.8937 27.9909 92.6585 27.9909C87.8409 27.9909 83.3398 24.1228 83.3398 18.7777C83.3398 13.292 87.5245 9.31836 92.6585 9.31836C95.753 9.31836 97.4409 10.7601 98.3201 12.237V9.7755H103.771ZM98.3201 17.3008C97.5113 14.8392 96.597 13.714 93.3267 13.714C90.6541 13.714 89.0014 15.226 89.0014 18.7777C89.0014 22.7513 90.619 23.9469 93.3618 23.9469C96.8783 23.9469 97.7574 22.7513 98.3201 20.2546V17.3008Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.933 9.70517V14.7689C120.37 14.5228 119.526 14.3821 118.471 14.3821C115.377 14.3821 113.302 15.859 113.302 19.8326V28.6239H107.852V9.7755H113.302V12.5184C114.252 10.5491 116.256 9.31836 118.788 9.31836C119.597 9.31836 120.405 9.45902 120.933 9.70517Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.384 24.1931V28.6239H141.575C138.48 28.6239 137.355 27.8151 136.546 26.3381C135.702 27.9557 133.1 29.081 130.041 29.081C126.173 29.081 122.41 27.1469 122.41 22.9272C122.41 18.7777 126.735 16.9843 130.779 16.9843C132.242 16.9582 133.689 17.2839 134.999 17.9337V16.5272C134.999 14.3469 134.296 13.4678 131.659 13.4678C129.83 13.4678 128.88 13.7491 128.423 15.1206H123.113C124.45 10.9359 127.579 9.31836 131.623 9.31836C137.32 9.31836 140.45 12.0261 140.45 16.7381V22.6107C140.45 23.8414 141.012 24.1931 141.927 24.1931H142.384ZM134.999 21.4502C134.05 20.7821 133.171 20.3953 130.955 20.3953C128.705 20.3953 128.001 21.0634 128.001 22.7162C128.001 24.2634 128.705 24.9315 130.744 24.9315C132.854 24.9315 133.979 24.6502 134.999 23.2788V21.4502Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.066 0.457329V4.85293C157.095 4.57092 156.088 4.42884 155.077 4.43096C153.424 4.43096 152.44 5.20458 152.44 7.20898V9.77601H157.714V14.2068H152.44V28.6244H146.989V14.2068H143.262V9.77601H146.989V7.17381C146.989 3.02436 150.224 0.00018517 154.198 0.00018517C155.501 -0.00609576 156.8 0.147432 158.066 0.457329Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7745 18.5952C80.7745 24.233 76.4578 28.1387 70.4506 28.1387C64.4072 28.1387 60.125 24.233 60.125 18.5952C60.125 12.9914 64.4072 9.05176 70.4506 9.05176C76.4595 9.05346 80.7745 12.9914 80.7745 18.5952Z",
    fill: "#222222",
    stroke: "url(#paint0_linear_3196_31630)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1911 24.6722C75.022 24.6721 77.7844 23.8168 80.1046 22.2218C78.6714 25.8388 75.0592 28.1398 70.4506 28.1398C68.218 28.1398 66.2254 27.6049 64.6006 26.6488C65.0876 26.0341 65.7106 25.5365 66.4224 25.194C67.1342 24.8515 67.916 24.6731 68.7084 24.6722H72.1911ZM72.1911 21.2471H68.7084C67.4256 21.2471 66.1589 21.5271 64.9995 22.0668C63.84 22.6066 62.8168 23.3926 62.0037 24.3682C62.3588 24.829 62.759 25.2545 63.1985 25.6384C63.847 24.807 64.6812 24.1333 65.6365 23.6692C66.5919 23.2052 67.6429 22.9633 68.7084 22.9622H72.1911C75.3908 22.9625 78.4612 21.7206 80.7348 19.5065C80.7607 19.2076 80.7745 18.9054 80.7745 18.598C80.7749 18.0596 80.7333 17.522 80.6502 16.9899C79.6841 18.3079 78.4133 19.3812 76.9425 20.1214C75.4718 20.8615 73.8433 21.2474 72.1911 21.2471ZM72.1911 12.6852C72.6526 12.6847 73.0951 12.5042 73.4214 12.1833C73.7477 11.8624 73.9312 11.4273 73.9316 10.9734V9.53853C72.8009 9.21108 71.6277 9.04747 70.4489 9.05286C66.0338 9.05286 62.5614 11.1568 61.0091 14.4733C63.3998 13.3001 66.0348 12.6886 68.7067 12.6868L72.1911 12.6852ZM72.1911 16.1103C73.5139 16.1082 74.7867 15.6132 75.7531 14.7249C76.7195 13.8365 77.3076 12.621 77.3989 11.3233C76.8648 10.8965 76.286 10.5271 75.6722 10.2212V10.9734C75.6708 11.8814 75.3034 12.7518 74.6506 13.3939C73.9977 14.0359 73.1127 14.3972 72.1894 14.3986H68.7084C65.7169 14.3973 62.7887 15.2452 60.2752 16.8405C60.1745 17.4205 60.1243 18.0079 60.125 18.5963C60.125 18.7441 60.125 18.8884 60.1354 19.0344C62.5776 17.1399 65.5979 16.1103 68.7084 16.112L72.1911 16.1103ZM68.7084 19.5354H72.1911C73.82 19.5341 75.4157 19.0832 76.7967 18.2339C78.1777 17.3846 79.2885 16.1711 80.0027 14.7314C79.7113 14.0559 79.3355 13.4187 78.8838 12.8346C78.471 14.2683 77.5944 15.5306 76.3868 16.4306C75.1792 17.3305 73.7063 17.8189 72.1911 17.822H68.7084C65.6294 17.8238 62.6664 18.9773 60.4203 21.0484C60.5694 21.6656 60.7829 22.2659 61.0574 22.8399C62.0313 21.7991 63.214 20.968 64.5308 20.3993C65.8477 19.8305 67.2701 19.5363 68.7084 19.5354Z",
    fill: "url(#paint1_radial_3196_31630)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7745 18.5952C80.7745 24.233 76.4578 28.1387 70.4506 28.1387C64.4072 28.1387 60.125 24.233 60.125 18.5952C60.125 12.9914 64.4072 9.05176 70.4506 9.05176C76.4595 9.05346 80.7745 12.9914 80.7745 18.5952Z",
    stroke: "url(#paint2_linear_3196_31630)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.104 17.0959C171.719 17.803 176 18.8989 176 23.1059C176 27.5956 171.578 29.1865 167.121 29.1865C161.892 29.1865 159.049 27.136 158.066 22.9291H163.226C163.576 24.2725 164.173 25.0149 166.946 25.0149C169.332 25.0149 170.42 24.626 170.42 23.4594C170.42 22.116 169.894 21.8685 166.876 21.2675C163.436 20.5958 158.733 19.4292 158.733 15.1162C158.733 11.1213 162.664 9.31836 167.226 9.31836C171.929 9.31836 174.948 11.3688 175.825 15.1869H170.666C170.175 13.9849 169.613 13.49 167.402 13.49C165.051 13.49 164.243 13.9849 164.243 15.0808C164.243 16.106 165.015 16.4949 168.104 17.0959Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3196_31630",
    x1: 59.6933,
    y1: 18.5969,
    x2: 81.2062,
    y2: 18.5969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3196_31630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.4506 18.5963) scale(10.02 9.85422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3196_31630",
    x1: 59.6933,
    y1: 18.5969,
    x2: 81.2062,
    y2: 18.5969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogo);
export default __webpack_public_path__ + "static/media/menu-logo.9ce504cc4e25b899e243df59d4bfc7e3.svg";
export { ForwardRef as ReactComponent };